const MASK = "***";
const VISIBLE_LOCAL_PART_LENGTH = 3;

// "jan.kowalski@gmail.com" -> "jan***@gmail.com"; a local part of up to 3 characters keeps only its first one ("jan@gmail.com" -> "j***@gmail.com")
export const maskEmail = (email: string | null | undefined): string | null => {
    const trimmedEmail = email?.trim() ?? "";
    const atIndex = trimmedEmail.lastIndexOf("@");

    if (atIndex < 1 || atIndex === trimmedEmail.length - 1) {
        return null;
    }

    const localPart = trimmedEmail.slice(0, atIndex);
    const visibleLength = localPart.length > VISIBLE_LOCAL_PART_LENGTH ? VISIBLE_LOCAL_PART_LENGTH : 1;

    return `${localPart.slice(0, visibleLength)}${MASK}${trimmedEmail.slice(atIndex)}`;
};
const MASK = "***";
const VISIBLE_LOCAL_PART_LENGTH = 3;

// "jan.kowalski@gmail.com" -> "jan***@gmail.com"; a local part of up to 3 characters keeps only its first one ("jan@gmail.com" -> "j***@gmail.com")
export const maskEmail = (email: string | null | undefined): string | null => {
    const trimmedEmail = email?.trim() ?? "";
    const atIndex = trimmedEmail.lastIndexOf("@");

    if (atIndex < 1 || atIndex === trimmedEmail.length - 1) {
        return null;
    }

    const localPart = trimmedEmail.slice(0, atIndex);
    const visibleLength = localPart.length > VISIBLE_LOCAL_PART_LENGTH ? VISIBLE_LOCAL_PART_LENGTH : 1;

    return `${localPart.slice(0, visibleLength)}${MASK}${trimmedEmail.slice(atIndex)}`;
};
